module.exports = __webpack_public_path__ + "static/media/box-full.e4f14223.svg";